<template>
  <div id="thankyou_page">
    <header-section :title="'Thank you!'"></header-section>
    <div class="container">
      <div class="thankyou_element">
        <!-- <div class="thankyou_title">THANK YOU!</div> -->
        <div class="content">
          <i class="fa fa-check"></i>
        </div>
      </div> 
      <div class="thankyou_content">
        <div class="no_name">
          <p>Cảm ơn bạn đã đăng ký trở thành Cố vấn trên Moranow</p> 
          <p>Vui lòng kiểm tra Email để biết thêm về thông tin tài khoản</p>
          <p>Chúng tôi sẽ liên hệ hợp tác với bạn trong thời gian sớm nhất</p>
          <div>
            <a href="/login" class="btn btn-success">Đăng nhập</a>  
            <a href="/" class="btn btn-success">Trở về trang chủ</a>
          </div>
          
        </div>        
      </div>      
    </div>   
  </div>
</template>
<script>
  import HeaderSection from './components/Common/HeaderSection.vue'
  import {mapState, mapGetters} from 'vuex'
  export default{
    components:{
      HeaderSection
    },
    computed:{
      ...mapGetters( 'user', [
        'isAuthenticated'
      ]),
    },
    created: function(){
    },
    methods:{
      register_now: function(){
        this.$store.dispatch('user/sign_up_without_password', {email: this.appointment.customer_email, name: this.appointment.customer_name})
      }
    }
  };
</script>
<style lang="scss" scoped>
  @import "./components/HomePage/common";
  @import "./components/Responsive/query";
  #thankyou_page{
    .container{
      .thankyou_element{
        text-align: center;
        font-size: 100px;
        .thankyou_title{          
          font-weight: 900;
          @include for-mobile-only{
            font-size: 50px;
          }
        }
        .content{
          i{
            color: #24b663;
          }
        }
      }
      .thankyou_content{
        text-align: center;
        font-size: 20px;
        p{
          font-size: 20px;
        }
        .next_step_question{
          padding-bottom: 10px;
        }
        table.info_appointment{
          width: 550px;          
          margin: auto;
          border: 1px solid black;
          td{
            text-align: left;
            border: 1px solid black
          }
        }        
      }
      .next_step{
        padding-top: 10px;    
        font-size: 20px;
        font-weight: 700;        
        text-align: center;
        .register_now{
          margin-top: 10px;
        }
      }
    }
  }
  
</style>


// WEBPACK FOOTER //
// src/views/ThankCounselor.vue